export const MAX_SHOW_ALL_THRESHOLD = 7;
const UPPER_AND_LOWER_BOUNDARY = 4;
const SHOW_AROUND_MIDDLE_ELEMENT = 1;

/**
 * Determines whether a specific page should be displayed in a pagination component.
 * Note: It is assumed that the first and last page are always shown
 *
 * @param page - The page number being evaluated.
 * @param numberOfPages - The total number of pages available.
 * @param activePage - The currently active page number.
 * @returns A boolean indicating whether the `currentPage` should be shown.
 */
export const shouldShowPage = (page: number, numberOfPages: number, activePage: number) => {
  if (page === 1 || page === numberOfPages) {
    return true;
  }

  if (activePage <= UPPER_AND_LOWER_BOUNDARY) {
    return page <= UPPER_AND_LOWER_BOUNDARY + 1;
  }
  if (activePage > numberOfPages - UPPER_AND_LOWER_BOUNDARY) {
    return page > numberOfPages - (UPPER_AND_LOWER_BOUNDARY + 1);
  }
  return Math.abs(page - activePage) <= SHOW_AROUND_MIDDLE_ELEMENT;
};
